import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PendingAttempt {
  exerciseId: string;
  attemptData: { structure: string; score: number; feedback?: unknown };
  returnPath: string;
}

interface PendingVocabWord {
  word: string;
  context?: string;
  context_sentence?: string;
  context_translation?: string;
  exercise_id?: number;
  module_id?: number;
  course_id?: number;
  hint_cefr_level?: string;
  hint_category?: string;
  hint_part_of_speech?: string;
  hint_gender?: string;
  hint_plural?: string;
  hint_present_er?: string;
  hint_prateritum?: string;
  hint_perfekt?: string;
}

interface DeferredActionsState {
  pendingAttempt: PendingAttempt | null;
  pendingVocabWords: PendingVocabWord[];
}

const STORAGE_KEY = "deferredActions";

function loadFromStorage(): DeferredActionsState {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch { /* ignore */ }
  return { pendingAttempt: null, pendingVocabWords: [] };
}

function saveToStorage(state: DeferredActionsState) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch { /* ignore */ }
}

const deferredActionsSlice = createSlice({
  name: "deferredActions",
  initialState: loadFromStorage(),
  reducers: {
    setPendingAttempt(state, action: PayloadAction<PendingAttempt>) {
      state.pendingAttempt = action.payload;
      saveToStorage(state);
    },
    clearPendingAttempt(state) {
      state.pendingAttempt = null;
      saveToStorage(state);
    },
    addPendingVocabWord(state, action: PayloadAction<PendingVocabWord>) {
      state.pendingVocabWords.push(action.payload);
      saveToStorage(state);
    },
    clearPendingVocabWords(state) {
      state.pendingVocabWords = [];
      saveToStorage(state);
    },
    clearAllDeferredActions(state) {
      state.pendingAttempt = null;
      state.pendingVocabWords = [];
      sessionStorage.removeItem(STORAGE_KEY);
    },
  },
});

export const {
  setPendingAttempt,
  clearPendingAttempt,
  addPendingVocabWord,
  clearPendingVocabWords,
  clearAllDeferredActions,
} = deferredActionsSlice.actions;

export default deferredActionsSlice.reducer;
